var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Instructions Page"},[_c('h1',[_vm._v(_vm._s(_vm.page.admin[_vm.lang].title))]),_c('InstructionsBlock')],1)}
var staticRenderFns = []

export { render, staticRenderFns }